import { Eligibility } from "@decibeltrade/sdk";
import { FetchQueryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { readDexSdk } from "../../dex-sdk";

export interface GetFundedTrialEligibilityArgs {
  account: string;
}

export function fundedTrialEligibilityQueryKey({ account }: GetFundedTrialEligibilityArgs) {
  return ["fundedTrialEligibility", account] as const;
}

export function fundedTrialEligibilityQuery({ account }: GetFundedTrialEligibilityArgs) {
  return {
    queryKey: fundedTrialEligibilityQueryKey({ account }),
    queryFn: async (): Promise<Eligibility> => {
      return readDexSdk.fundedFirstTrade.getEligibility({ account });
    },
    // Eligibility is composed from view-fn calls (no WS push). Light refetch
    // keeps pause-flag changes / fresh credits visible without thrashing.
    staleTime: 10_000,
  } satisfies FetchQueryOptions;
}

export function useFundedTrialEligibility(args: GetFundedTrialEligibilityArgs) {
  return useSuspenseQuery(fundedTrialEligibilityQuery(args));
}

export function useFundedTrialEligibilityQuery(args: { account: string | undefined }) {
  return useQuery({
    ...fundedTrialEligibilityQuery({ account: args.account ?? "" }),
    enabled: !!args.account,
  });
}
